<template>
  <el-drawer
    v-model="visible"
    title="Nuevo Suaje"
    size="70%"
    :direction="direction"
    center
    @close="closeModal"
  >
    <el-form
      ref="formSuajeRef"
      :model="swage"
      :rules="formSuajeRules"
      size="default"
      class="form-container"
    >
      <el-row :gutter="24">
        <el-col :span="4">
          <el-form-item prop="CodigoSuaje">
            <custom-input
              v-model="swage.CodigoSuaje"
              :label="'Código'"
              :settings="{
                placeholder: 'Código de suaje',
              }"
            ></custom-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="CodigoAdicional">
            <custom-input
              v-model="swage.CodigoAdicional"
              :label="'Código adicional'"
              :settings="{
                placeholder: 'Código interno adicional',
                maxlength: 100,
              }"
            ></custom-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="Descripcion">
            <custom-input
              v-model="swage.Descripcion"
              :label="'Descripción'"
              :settings="{
                placeholder: 'Descripción del suaje',
                maxlength: 255,
              }"
            ></custom-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="SuajeTipo">
            <custom-select
              v-model="swage.SuajeTipo"
              :label="'Tipo suaje'"
              :settings="{
                placeholder: 'Seleccionar tipo de suaje',
                options: claseSuaje,
              }"
            ></custom-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="Forma">
            <custom-select
              v-model="swage.Forma"
              :label="'Forma'"
              :settings="{
                placeholder: 'Seleccionar forma',
                options: formaList,
              }"
            ></custom-select>
          </el-form-item>
        </el-col>
        <el-col :span="1"></el-col>
        <el-col
          :span="4"
          class="custom-col"
        >
          <div class="custom-label">Aplicación</div>
          <el-switch
            v-model="swage.EsAutomatica"
            active-text="Automatico"
            inactive-text="Manual"
            class="mb-2"
            sieze="large"
          />
        </el-col>
        <el-col
          :span="3"
          class="custom-col"
        >
          <div class="custom-label">Pleca</div>
          <el-switch
            v-model="swage.TienePleca"
            active-text="Si"
            inactive-text="No"
            class="mb-2"
            sieze="large"
          />
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-form-item prop="MedidaEjeMm">
          <custom-input-number
            v-model="swage.MedidaEjeMm"
            :label="'Medida al Eje (mm)'"
            :settings="{
              placeholder: 'Medida al Eje (mm)',
              precision: 4,
              step: 0.01,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item prop="MedidaDesarrolloMm">
          <custom-input-number
            v-model="swage.MedidaDesarrolloMm"
            :label="'Medida Desarrollo (mm)'"
            :settings="{
              placeholder: 'Medida desarrollo (mm)',
              precision: 4,
              step: 0.01,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item prop="MedidaEjeIn">
          <custom-input-number
            v-model="swage.MedidaEjeIn"
            :label="'Medida al Eje (in)'"
            :settings="{
              placeholder: 'Medida al Eje (in)',
              precision: 4,
              disabled: true,
              step: 0.01,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item prop="MedidaDesarrolloIn">
          <custom-input-number
            v-model="swage.MedidaDesarrolloIn"
            :label="'Medida Desarrollo (in)'"
            :settings="{
              placeholder: 'Medida desarrollo (in)',
              precision: 4,
              disabled: true,
              step: 0.01,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-col :span="2"></el-col>
        <el-col
          :span="4"
          class="custom-col"
        >
          <div class="custom-label">Tipo corte</div>
          <el-switch
            v-model="swage.EsCorteCompleto"
            active-text="Completo"
            inactive-text="Medio corte"
            class="mb-2"
            sieze="large"
          />
        </el-col>
        <el-col
          :span="3"
          class="custom-col"
        >
          <div class="custom-label">Activo</div>
          <el-switch
            v-model="swage.Activo"
            active-text="Activo"
            inactive-text="Inactivo"
            class="mb-2"
            sieze="large"
          />
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="4">
          <el-form-item prop="CilindroTipo">
            <custom-select
              v-model="swage.CilindroTipo"
              :label="'Tipo Cilindro'"
              :settings="{
                placeholder: 'Seleccionar cilindro',
                options: cilindroTipoList,
              }"
            ></custom-select>
          </el-form-item>
        </el-col>
        <el-form-item prop="Engranaje">
          <custom-input-number
            v-model="swage.Engranaje"
            :label="'Engrane'"
            :settings="{
              placeholder: 'Engrane',
              precision: 0,
              step: 0.01,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item prop="Desarrollo">
          <custom-input-number
            v-model="swage.Desarrollo"
            :label="'Desarrollo (mm)'"
            :settings="{
              placeholder: 'Desarrollo',
              precision: 4,
              step: 0.01,
              disabled: !esSuajePlano,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item prop="AnchoOptimoMaterial ">
          <custom-input-number
            v-model="swage.AnchoOptimoMaterial"
            :label="'Ancho mínimo (mm)'"
            :settings="{
              placeholder: 'Ancho mínimo',
              precision: 4,
              step: 0.01,
              disabled: true,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
      </el-row>
      <el-row :gutter="24">
        <el-form-item prop="EtiquetasEje">
          <custom-input-number
            v-model="swage.EtiquetasEje"
            :label="'Etiquetas eje'"
            :settings="{
              placeholder: 'Etiquetas eje',
              precision: 0,
              step: 0.01,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item prop="EtiquetasDesarrollo">
          <custom-input-number
            v-model="swage.EtiquetasDesarrollo"
            :label="'Etiquetas desarrollo'"
            :settings="{
              placeholder: 'Etiquetas desarrollo',
              precision: 0,
              step: 0.01,
              disabled: false,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item prop="MinEtiquetaImpresa">
          <custom-input-number
            v-model="swage.MinEtiquetaImpresa"
            :label="'Minimo etiqueta impresa'"
            :settings="{
              placeholder: 'Minimo etiqueta impresa',
              precision: 0,
              step: 0.01,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item prop="MinEtiquetaSinImpresion">
          <custom-input-number
            v-model="swage.MinEtiquetaSinImpresion"
            :label="'Minimo etiqueta sin impresión'"
            :settings="{
              placeholder: 'Minimo etiqueta sin impresión',
              precision: 0,
              step: 0.01,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item
          prop="Material"
          style="margin-left: 2%"
        >
          <div class="custom-label">Material</div>
          <el-autocomplete
            v-model="swage.Material.Descripcion"
            size="default"
            :value-key="'Descripcion'"
            :fetch-suggestions="handleSearch"
            clearable
            placeholder="Ingresar el item"
            style="width: 100%"
            @select="handleMaterialSelect"
          />
        </el-form-item>
      </el-row>
      <el-row :gutter="24">
        <el-form-item prop="GapEjeMm">
          <custom-input-number
            v-model="swage.GapEjeMm"
            :label="'Gap al Eje (mm)'"
            :settings="{
              placeholder: 'Gap al Eje (mm)',
              precision: 4,
              step: 0.01,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item prop="GapDesarrolloMm">
          <custom-input-number
            v-model="swage.GapDesarrolloMm"
            :label="'Gap al Desarrollo (mm)'"
            :settings="{
              placeholder: 'Gap desarrollo (mm)',
              precision: 4,
              step: 0.01,
              disabled: !esSuajePlano,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item prop="GapEjeIn">
          <custom-input-number
            v-model="swage.GapEjeIn"
            :label="'Gap al Eje (in)'"
            :settings="{
              placeholder: 'Gap al Eje (in)',
              precision: 4,
              step: 0.01,
              disabled: true,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-form-item prop="GapDesarrolloIn">
          <custom-input-number
            v-model="swage.GapDesarrolloIn"
            :label="'Gap al Desarrollo (in)'"
            :settings="{
              placeholder: 'gap al Desarrollo (in)',
              precision: 4,
              step: 0.01,
              disabled: true,
              controls: false,
            }"
          ></custom-input-number>
        </el-form-item>
        <el-col :span="6">
          <el-form-item prop="familiaMaterialSelected">
            <custom-select
              v-model="familiaMaterialSelected"
              :label="'Familia'"
              :settings="{
                placeholder: 'Seleccionar familia',
                multiple: true,
                options: materiaPrimaFamilias,
              }"
            ></custom-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-form-item prop="Observaciones">
          <custom-input
            v-model="swage.Observaciones"
            :label="'Observaciones'"
            :type="'textarea'"
            :spanColumn="24"
            :settings="{
              placeholder: 'Notas técnicas sobre el troquel',
              rows: 3,
            }"
          ></custom-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="6">
          <custom-confirm-buttons
            :disabled="false"
            :confirmText="'Guardar'"
            :cancelText="'Cancelar'"
            @on-cancel="onCancel"
            @on-confirm="handleSave"
          ></custom-confirm-buttons>
        </el-col>
      </el-row>
    </el-form>
  </el-drawer>
</template>

<script setup>
import {
  ref,
  onBeforeMount,
  watch,
  computed,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useSwageStore } from '@/stores/swage_store.js';
import { useFormaStore } from '@/stores/forma/forma_store.js';
import { useCilindroTipoStore } from '@/stores/cilindro-tipo/cilindro-tipo';
import { useConfiguracionStore } from '@/stores/configuracion-general';
import { useMaterialStore } from '@/stores/materiales_store.js';
import { useMateriaPrimaFamiliaStore } from '@/stores/materia_prima_familia/materia_prima_familia_store';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomConfirmButtons from '@/shared/components/custom_confirm_buttons.vue';
import { ElNotification } from 'element-plus';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
const visible = ref(false);
const direction = ref('btt');
const swageStore = useSwageStore();
const formaStore = useFormaStore();
const cilindroTipoStore = useCilindroTipoStore();
const configuracionStore = useConfiguracionStore();
const materialStore = useMaterialStore();
const materiaPrimaFamiliaStore = useMateriaPrimaFamiliaStore();

const { firstForma } = formaStore;
const { firstCilindroTipo } = cilindroTipoStore;

const { findConfiguracionByCodigoHTTP } = configuracionStore;
const { searchMaterialHTTP } = materialStore;
const { configuracion } = storeToRefs(configuracionStore);
const { formaList } = storeToRefs(formaStore);
const { cilindroTipoList } = storeToRefs(cilindroTipoStore);
const { swage, claseSuaje } = storeToRefs(swageStore);
const { materiaPrimaFamilias } = storeToRefs(materiaPrimaFamiliaStore);

const { resetNewSwage, newSwageHTTP, firstSwage, initialNewSwage, findAllClaseSuajeHTTP } =
  swageStore;
const formSuajeRef = ref(null);
const familiaMaterialSelected = ref([]);

// Un suaje "plano" no usa engrane y su desarrollo y gap los define el usuario
const esSuajePlano = computed(() => swage.value.SuajeTipo?.ClaveInterna === 'plano');

const formSuajeRules = computed(() => ({
  CodigoSuaje: [{ required: true, message: 'Ingresar código suaje', trigger: 'blur' }],
  EtiquetasEje: [{ required: true, message: 'Ingresar etiqueta eje', trigger: 'blur' }],
  Engranaje: esSuajePlano.value
    ? []
    : [{ required: true, message: 'Ingresar engrane', trigger: 'blur' }],
  Desarrollo: esSuajePlano.value
    ? [{ required: true, message: 'Ingresar desarrollo (mm)', trigger: 'blur' }]
    : [],
  GapEjeMm: [{ required: true, message: 'Ingresar gap Eje (mm)', trigger: 'blur' }],
  MedidaEjeMm: [{ required: true, message: 'Ingresar medida eje (mm)', trigger: 'blur' }],
  MedidaDesarrolloMm: [
    { required: true, message: 'Ingresar medida desarrollo (mm)', trigger: 'blur' },
  ],
  SuajeTipo: [{ required: true, message: 'Seleccionar un tipo', trigger: 'change' }],
  Forma: [{ required: true, message: 'Seleccionar una forma', trigger: 'change' }],
  CilindroTipo: esSuajePlano.value
    ? []
    : [{ required: true, message: 'Seleccionar un tipo', trigger: 'change' }],
  EtiquetasDesarrollo: [
    {
      validator: (rule, value, callback) => {
        if (value < 1) {
          callback(new Error('El valor de Etiquetas Desarrollo debe ser mayor a uno'));
        } else {
          callback();
        }
      },
      trigger: 'change',
    },
  ],
  GapDesarrolloMm: [
    {
      validator: (rule, value, callback) => {
        if (value < 0) {
          callback(new Error('El gap desarrollo (mm) no puede ser negativo'));
        } else if (value < configuracion.value.Valor) {
          callback(
            new Error(
              `El gap desarrollo (mm) no puede ser menor al gap mínimo de ${configuracion.value.Valor}`,
            ),
          );
        } else {
          callback();
        }
      },
      trigger: 'change',
    },
  ],
}));

const emit = defineEmits(['closed']);
const closeModal = () => {
  visible.value = false;
  familiaMaterialSelected.value = [];
  resetNewSwage();
  resetFormValidation(); // Restablece las reglas de validación
  emit('closed');
};

const handleSearch = async (query, cb) => {
  let results = [];
  if (query && query.length >= 3 && query !== 'null') {
    results = await searchMaterialHTTP(query);
  }
  cb(results || []);
};

const handleMaterialSelect = (item) => {
  swage.value.Material = item;
  swage.value.CodigoMaterial = item.Codigo;
};

function toFourDecimals(num) {
  return parseFloat(num.toFixed(4));
}
// Watcher para convertir mm a in
watch(
  () => swage.value.MedidaEjeMm,
  (nuevoValor) => {
    swage.value.MedidaEjeIn = toFourDecimals(nuevoValor * 0.0393701); // Conversión de mm a in
  },
);

watch(
  () => swage.value.GapEjeMm,
  (nuevoValor) => {
    swage.value.GapEjeIn = toFourDecimals(nuevoValor * 0.0393701); // Conversión de mm a in
  },
);

watch(
  () => swage.value.GapDesarrolloMm,
  (nuevoValor) => {
    swage.value.GapDesarrolloIn = toFourDecimals(nuevoValor * 0.0393701); // Conversión de mm a in
  },
);

watch(
  () => swage.value.MedidaDesarrolloMm,
  (nuevoValor) => {
    swage.value.MedidaDesarrolloIn = toFourDecimals(nuevoValor * 0.0393701); // Conversión de mm a in
  },
);

// Verifica que solo haya un watcher para GapEjeMm a GapEjeIn
watch(
  () => swage.value.GapEjeMm,
  (nuevoValor) => {
    swage.value.GapEjeIn = toFourDecimals(nuevoValor * 0.0393701); // Conversión de mm a in
  },
);

// Watcher para Desarrollo y Engranaje: en suajes planos el desarrollo lo carga el usuario,
// en el resto se recalcula a partir del engrane
watch(
  [() => swage.value.CilindroTipo, () => swage.value.Engranaje, esSuajePlano],
  ([nuevoPaso, nuevoEngranaje, esPlano]) => {
    if (!esPlano && nuevoPaso !== null && nuevoEngranaje !== null) {
      swage.value.Desarrollo = toFourDecimals(nuevoEngranaje * 3.175);
    }
  },
  { immediate: true },
);

// Al pasar a plano, limpiar la validación pendiente de Engranaje y CilindroTipo (dejan de ser obligatorios)
watch(esSuajePlano, (esPlano) => {
  if (esPlano) {
    formSuajeRef.value?.clearValidate(['Engranaje', 'CilindroTipo']);
  }
});

// Watcher para AnchoOptimoMaterial
watch(
  [() => swage.value.MedidaEjeMm, () => swage.value.GapEjeMm, () => swage.value.EtiquetasEje],
  ([nuevaMedida, nuevoGap, nuevaEtiqueta]) => {
    if (nuevaMedida !== null && nuevoGap !== null && nuevaEtiqueta !== null) {
      swage.value.AnchoOptimoMaterial = toFourDecimals((nuevaMedida + nuevoGap) * nuevaEtiqueta);
    }
  },
  { immediate: true },
);

// Watcher para GapDesarrolloMm: en suajes planos el gap lo carga el usuario,
// en el resto se recalcula a partir del desarrollo, la medida y las etiquetas
watch(
  [
    () => swage.value.Desarrollo,
    () => swage.value.MedidaDesarrolloMm,
    () => swage.value.EtiquetasDesarrollo,
    esSuajePlano,
  ],
  ([nuevoDesarrollo, nuevaMedida, nuevaEtiqueta, esPlano]) => {
    if (!esPlano && nuevoDesarrollo !== null && nuevaMedida !== null && nuevaEtiqueta !== null) {
      swage.value.GapDesarrolloMm = toFourDecimals(
        (nuevoDesarrollo - nuevaEtiqueta * nuevaMedida) / nuevaEtiqueta,
      );
    }
  },
  { immediate: true },
);

const onCancel = () => {
  closeModal();
};
const resetFormValidation = () => {
  if (formSuajeRef.value) {
    formSuajeRef.value.resetFields();
  }
};

watch(familiaMaterialSelected, (newValue) => {
  swage.value.SuajeMateriaPrimaFamilia = [];
  familiaMaterialSelected.value.forEach((item) => {
    const newItem = {
      CodigoMateriaPrimaFamilia: item.Codigo,
      MateriaPrimaFamilia: {
        Codigo: item.Codigo,
        Descripcion: item.Descripcion,
        CodigoAdicional: item.CodigoAdicional,
        Activo: item.Activo,
      },
    };
    swage.value.SuajeMateriaPrimaFamilia.push(newItem);
  });
});

const handleSave = async () => {
  formSuajeRef.value.validate(async (valid) => {
    if (valid) {
      try {
        useLoading().openLoading();
        await newSwageHTTP();
        useMessageSuccess().open(`Los datos se guardaron existosamente!`);
        closeModal();
      } catch (err) {
        useMessageError().open(`Ha ocurrido un error al intentar guardar los datos.`);
      } finally {
        useLoading().closeLoading();
        await firstSwage();
      }
    } else {
      ElNotification({
        title: 'Nuevo suaje',
        message: 'Por favor, revise los campos ingresados.',
        type: 'warning',
      });
    }
  });
};

onBeforeMount(() => {
  //Codigo 9 para el gap minimo
  findConfiguracionByCodigoHTTP(9);
  resetNewSwage();
  materiaPrimaFamiliaStore.emptyList();
  materiaPrimaFamiliaStore.findAllfamiliaMaterialHTTP({
    page: 0,
    sortBy: 'Descripcion',
    sort: 'asc',
  });
  firstCilindroTipo();
  firstForma();
  initialNewSwage();
});
</script>

<style scoped>
.custom-label {
  font-weight: 700;
  color: #111;
}

.custom-col {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.input-margin {
  margin-top: 2%;
}

.form-container {
  margin: 0 20px 0px 5%;
  /* Margen superior, derecha, inferior, izquierda */
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin: 3%;
}
.full-width {
  width: 100%;
}
</style>
